/* unplugin-vue-components disabled */import script from "./health-number-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./health-number-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./health-number-dialog.vue?vue&type=style&index=0&id=8e5bd756&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e5bd756"]])

export default __exports__